import { hardcodeDropdown } from "modules/paymentManagement/common/services";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { endpoint } from "views/pages/manage/common/constant";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { getFilterCount } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant"

const FilterForm = ({
  closePopup,
  dropdownData,
  filterForm,
  setFilterForm,
  filterCount,
  setFilterCount,
  applyFilterHandler,
  handleFilterForm,
  removeFilterHandler
}) => {

  const resetFilterForm = () => {
    setFilterCount(0);
    removeFilterHandler();
    closePopup();
  };


  const { allActiveBu } = dropdownData;

  const handleApplyFilter = () => {
    let fCount = getFilterCount({ ...filterForm });
    setFilterCount(fCount);
    applyFilterHandler();
    closePopup();
  };

  const [cashierItems, setCashierItems] = useState([]);
  const [isCashierLoading, setIsCashierLoading] = useState(false);

  useEffect(() => {
    const fetchCashiers = async () => {
      try {
        setIsCashierLoading(true);
        const data = await fetchAllPromisedData(endpoint?.businessArea?.getCashierOfficeDetails);
        if (Array.isArray(data)) {
          const transformed = data.map((item) => ({
            label: item?.businessAreaDispValue,
            value: item?.businessAreaDispValue,
            raw: item,
          }));
          setCashierItems(transformed)
        } else {
          console.log("Invalid response format for cashier office list.");
        }
      } catch (e) {
        console.log(e);
      }
      finally {
        setIsCashierLoading(false);
      }
    }
    fetchCashiers();
  }, []);

  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="mb-1 d-flex align-items-start justify-content-between">
          <div className="regular-large-bold">Filters</div>
        </div>

        <div className="d-flex flex-column gap-md">
          <AAutoComplete
            label="Branch"
            currentValue={filterForm?.businessAreas}
            items={allActiveBu}
            handleChange={(value) => {
              handleFilterForm("businessAreas", value);
            }}
            selectAllMenuButton={true}
            isShowCount={true}
            isMulti={true}
          />

          <AAutoComplete
            label="Cashier’s Ofc"
            currentValue={filterForm?.cashierOffices}
            items={cashierItems}
            handleChange={(value) => {
              handleFilterForm("cashierOffices", value);
            }}
            selectAllMenuButton={true}
            isShowCount={false}
            isMulti={false}
            isLoading={isCashierLoading}
          />

          <AAutoComplete
            label="Paymode Type"
            currentValue={filterForm?.paymodeTypes}
            items={hardcodeDropdown?.paymodeTypes}
            handleChange={(value) => {
              handleFilterForm("paymodeTypes", value);
            }}
            selectAllMenuButton={true}
            isShowCount={true}
            isMulti={true}
          />

        </div>
        <div className="mt-3 d-flex flex-row-reverse justify-content-between">
          <AButton
            variant="primary_filled"
            className="button_remove_left_margin"
            onClick={() => {
              handleApplyFilter();
            }}
            disabled={getFilterCount({ ...filterForm }) == 0}
          >
            Apply filter
          </AButton>

          {filterCount > 0 && (
            <AButton
              variant="outline"
              className="button_remove_left_margin"
              updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
              onClick={resetFilterForm}
            >
              Remove filter
            </AButton>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default FilterForm;